module.exports = __webpack_public_path__ + "static/media/Show.27fb9e66.svg";